import React, { useState, useEffect, useRef } from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';

import GQLogoComponent from '../../shared/components/GQLogoComponent';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Row, Col } from 'react-bootstrap';
import { useTranslation, } from "react-i18next";
import NewsUpdate from '../../shared/NewsUpdate';
import { makeStyles } from '@material-ui/core/styles';
import { submitLogin, submitMfaCode, resendMfaCode } from '../../reducers/slice/loginSlice';
import Validate from '../../helpers/validate';
import TextInput from '../../shared/Fields/TextInput';
import Footer from '../../shared/footer';
import { supportMail } from '../../config';
import { containerWidth } from '../../shared/constants'
import { useAuth } from 'react-oidc-context';
import useAuthSession from '../../hooks/useAuthSession';
import { getSsoInFlight, resolveSsoLoginData, setSsoInFlight } from '../../services/storage/GQStorage';



const useStyles = makeStyles((theme) => ({
    container: {
        minWidth: containerWidth,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    contentContainer: {
        width: containerWidth,
        padding: '0 0 0 20px',
        marginLeft: '20px'
    },
    loginBox: {
        borderRight: '1px solid #bfb4b4'
    },
    loginDiv: {
        border: '2px solid #bfb4b4',
        borderRadius: '6px',
        padding: '20px',
        height: '100%'
    },
    navbarClass: {
        marginTop: '60px',
        width: '100%'
    },
    loginSubmitDis: {
        backgroundColor: '#EEEEEE',
        // borderColor: '#a2a2a3',
        border: '1px solid #CCCCCC',
        float: 'right',
        color: '#777777',
        textTransform: 'capitalize',
        '&:hover': {
            // backgroundColor: '#EEEEEE',
            pointerEvents: 'none',
            boxShadow: 'none',
        },
    },
    forgotLink: {
        marginTop: '10px',
        a: {
            color: '#008EC5'
        }
    },
    loginLogoDiv: {
        position: 'relative',
        width: '100%'
    },
    root: {
        "& .Mui-error": {
            fontStyle: 'italic'
        },
        "& .MuiFormHelperText-root": {
            fontStyle: 'italic'
        }
    },
    checkbox: {
        color: '#bfb4b4',
        '&.Mui-checked': {
            color: '#008EC5'
        }
    }
}));
//import { userActions } from '../_actions';
function Login(props) {

    const history = useHistory();
    const classes = useStyles();
    const [errorMsg, setErrorMsg] = useState(false);
    const { t } = useTranslation('common');
    const [errorMsgText, setErrorMsgText] = useState(t('loginFailure1'));
    const [loginTry, setLoginTry] = useState();
    const dispatch = useDispatch();
    const toastRef = useRef(null)
    const [btnClicked, setBtnClicked] = useState(false);
    const [ssoIsLoggingIn, setSsoIsLoggingIn] = useState(false);
    const [mfaRequired, setMfaRequired] = useState(false);
    const [securityCode, setSecurityCode] = useState('');
    const [resendCountdown, setResendCountdown] = useState(0);
    const [mfaToken, setMfaToken] = useState('');
    const [trustDevice, setTrustDevice] = useState(false);
    // Retrieve the saved path, or fallback to the dashboard
    const fromUrl = history.location.state?.from || "/home";

    const auth = useAuth();
    const authSession = useAuthSession();

    const checkKeyDown = (e) => {
        if (e.code === 'Enter') e.preventDefault();
    };

    const formik = useFormik({
        initialValues: {
            userName: '',
            password: '',
        },
        validationSchema: Validate.LoginValidate(),
        onSubmit: async (values) => {
            setBtnClicked(true);
            _Login({ GQUSERID: values.userName, GQPASSWORD: values.password });
        },
    });

    // reset login status
    useEffect(() => {
        if (authSession.isLoggedIn) {
            // Reused by /oauth-authorize: when an onLoginSuccess handler is
            // supplied, defer to it instead of navigating to /home.
            if (typeof props.onLoginSuccess === 'function') {
                props.onLoginSuccess();
            } else {
                history.push(fromUrl);
            }
        }
    }, [authSession.isLoggedIn, history]);

    useEffect(()=>{
        let ssoInFlight = getSsoInFlight();
        if(document.referrer.startsWith('https://appcentral')){
            if(!auth.isAuthenticated && auth.isLoading && !ssoInFlight){
                auth.signinRedirect();
                setSsoInFlight(true);
            }else if(!auth.isAuthenticated && !auth.isLoading ){
                setSsoInFlight(false)
            }
        }
    },[]);

    useEffect(()=>{
        if(auth.isAuthenticated && !ssoIsLoggingIn && !authSession.isLoggedIn){
            ssoLogin();
            setSsoIsLoggingIn(true)
        }
    },[auth.isAuthenticated, authSession.isLoggedIn])


    const ssoLogin = () => {
        const ssoData = resolveSsoLoginData();
        if (ssoData) {
            _Login(ssoData, true)
        } else {
            setSsoIsLoggingIn(false)
        }
    }

    async function _Login(data, isSSO = false){ //could not think of better name
        
        if(Object.entries(data).length > 0 ){
        let resp = await dispatch(submitLogin(data, history, t, toastRef, props.onLoginSuccess, fromUrl));
            if (resp && resp.response_status > 0) {

                if(isSSO){
                    setSsoInFlight(false);
                    auth.removeUser();
                    auth.revokeTokens();
                }

                if(resp.response_content.message === "NO_SSO_USER_FOUND"){
                    window.location.href = 'https://www.gqlifesciences.com/genomequest/';
                }

                if (resp.response_content.message === 'MFA_REQUIRED') {
                    setMfaToken(resp.response_content.mfaToken || '');
                    setMfaRequired(true);
                    setErrorMsg(false);
                    setBtnClicked(false);
                    return;
                }
                else if (resp.response_content.message === 'ACCOUNT_EXPIRED') {
                    setErrorMsgText(t('acctExpired'));
                    setLoginTry(-1); // Set to -1 to hide the link and button
                }
                else if (resp.response_content.triesLeft > 3) {
                    setErrorMsgText(t('loginFailure1'));
                }
                else if (resp.response_content.triesLeft === 3) {
                    setErrorMsgText(t('loginFailure2'));
                }
                else if (resp.response_content.triesLeft === 2) {
                    setErrorMsgText(t('loginFailure3'));
                }
                else if (resp.response_content.triesLeft === 1) {
                    setErrorMsgText(t('loginFailure4'));
                } else if (resp.response_content.triesLeft == null) {
                    setErrorMsgText(t('loginFailure1'));
                }
                else {
                    setErrorMsgText(t('loginFailure5'));
                }
                setLoginTry(resp.response_content.triesLeft)
                setErrorMsg(true);
                setBtnClicked(false);
            }
        }
        if (isSSO) {
            setSsoInFlight(false);
        }
        setSsoIsLoggingIn(false)
    }

    const [mfaBtnClicked, setMfaBtnClicked] = useState(false);

    useEffect(() => {
        if (!mfaRequired) return;
        setResendCountdown(60);
    }, [mfaRequired]);

    useEffect(() => {
        if (resendCountdown <= 0) return;
        const timer = setTimeout(() => setResendCountdown((c) => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [resendCountdown]);

    const handleVerifyMfa = async () => {
        setMfaBtnClicked(true);
        const resp = await dispatch(submitMfaCode(securityCode, formik.values.userName, mfaToken, trustDevice, history, t, toastRef));
        if (resp) {
            if (resp.response_content.message === 'MFA_FAILED') {
                if (resp.response_content.triesLeft && resp.response_content.triesLeft <= 3) {
                    setErrorMsgText(t('mfaFailure1') + resp.response_content.triesLeft + ' more tries');
                } else {
                    setErrorMsgText(t('mfaFailure'));
                }
                setErrorMsg(true);
            } else if (resp.response_content.message === 'LOGIN_PROHIBITED') {
                setErrorMsgText(t('loginFailure5'));
                setErrorMsg(true);
            } else if (resp.response_content.message === 'MFA_SESSION_EXPIRED') {
                setErrorMsgText(t('mfaExpired'));
                setErrorMsg(true);
            }
        }
        setMfaBtnClicked(false);
    };

    const handleResendMfa = async () => {
        await dispatch(resendMfaCode(formik.values.userName, mfaToken, history, t, toastRef));
        setResendCountdown(60);
    };

    const passwordVlaue = formik.values.userName;
    const passwordCnVlaue = formik.values.password;
    const passValCheck = passwordVlaue.length;
    const passValCheck1 = passwordCnVlaue.length;

    return (
        <div className={classes.container}>
            <Row className={classes.contentContainer}>
                <div className={"mt-100 " + classes.contentContainer}>
                    <Row className={classes.loginLogoDiv}>
                        <Col md="6" sm="6" xs='6' className="p-0 ml-4">
                            {/* <Link to="/login"><img src={GQLogo} alt="GQLogo" className="w-50" /></Link> */}
                            <GQLogoComponent toLink='#/login' />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col sm="5" md="5" xs='5' className={classes.loginBox + " mb-5"} >

                            <form name="loginForm" onSubmit={formik.handleSubmit}  className={classes.loginDiv + " content"}>
                                {!errorMsg && <h5 className="loginTitle">{t('loginAccount')}</h5>}
                                {errorMsg && <h6 className="loginFailedTitle">{errorMsgText}</h6>}
                                {errorMsg && loginTry === 0 &&
                                    <p>If you did not receive the email, please contact us at <a href={"mailto:" + supportMail}>{supportMail}</a>.</p>
                                }
                                <div className="form-group">
                                    <TextInput
                                        fullWidth
                                        id="userName"
                                        name="userName"
                                        label={t('userName')}
                                        variant="outlined"
                                        value={formik.values.userName}
                                        onChange={(e) => { formik.handleChange(e); setLoginTry(undefined); }}
                                        error={formik.touched.userName && Boolean(formik.errors.userName)}
                                        helperText={formik.touched.userName && formik.errors.userName}
                                    />
                                </div>
                                <div className="form-group">
                                    <TextInput
                                        fullWidth
                                        variant="outlined"
                                        id="password"
                                        name="password"
                                        label={t('password')}
                                        type="password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                </div>
                                {mfaRequired && (
                                    <div className="form-group">
                                        <p className="bodyText mb-1">{t('mfaRequired')}</p>
                                        <TextInput
                                            fullWidth
                                            variant="outlined"
                                            id="securityCode"
                                            name="securityCode"
                                            label={t('securityCode')}
                                            value={securityCode}
                                            onChange={(e) => setSecurityCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            error={securityCode.length > 0 && securityCode.length !== 6}
                                            helperText={securityCode.length > 0 && securityCode.length !== 6 ? t('securityCodeReq') : ''}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={trustDevice}
                                                    onChange={(e) => setTrustDevice(e.target.checked)}
                                                    className={classes.checkbox}
                                                    size="small"
                                                />
                                            }
                                            label={t('trustDevice')}
                                            style={{marginTop: '4px'}}
                                        />
                                        <div className="mt-2" style={{display: 'flex', gap: '8px'}}>
                                            {securityCode.length === 6 && !mfaBtnClicked ?
                                                <Button variant="contained" disableRipple={true} className='accountInfo' onClick={handleVerifyMfa}>{t('verify')}</Button> :
                                                <Button variant="contained" className='cancelButtonDisable' disableRipple={true}>{t('verify')}</Button>
                                            }
                                            {resendCountdown === 0 ?
                                                <Button variant="contained" disableRipple={true} className='accountInfo' onClick={handleResendMfa}>{t('resend')}</Button> :
                                                <Button variant="contained" className='cancelButtonDisable' disableRipple={true}>{t('resend')} ({resendCountdown}s)</Button>
                                            }
                                        </div>
                                    </div>
                                )}
                                {!mfaRequired && (
                                <div className="form-group">
                                    {/*<div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                                        <Button variant="contained" className='accountInfo' onClick={()=>singleSignOn()}>{t('AppCentral Single Sign On')}</Button>&nbsp;*/}
                                        {passValCheck !== 0 && passValCheck1 !== 0 && !btnClicked && !(errorMsg && loginTry <= 0) ?
                                            <Button variant="contained" disableRipple={true} className='accountInfo' type="submit">{t('submit')}</Button> :
                                            <Button variant="contained" className='cancelButtonDisable' disableRipple={true}>{t('submit')}</Button>
                                        }
                                    {/*</div>*/}
                                </div>
                                )}

                            </form>
                            {!(errorMsg && loginTry <= 0) && (
                            <p className={classes.forgotLink}>
                                <Link to="/forgot" className="m-0">{t('forgotLogin')}</Link>
                            </p>
                            )}
                        </Col>
                        <Col sm="5" md="5" xs="5">
                            <NewsUpdate isMostUsedPanel={true} />
                        </Col>
                    </Row>
                </div>
            </Row>
            <div className={classes.navbarClass}>
                <Footer />
            </div>
        </div>


    );
}

export default Login;